import { useContext, useEffect } from 'react';
import FlexibleRouting from '../../../ui-components/flexible-routing';
import { bookingState } from '../client-state/booking-state-context';
import { bookingActionTypes } from '../client-state/reducers/bookingReducer';
import useBookingDockingLocations from '../server-data/use-booking-docking-locations';
import { DockingLocationOperation } from '../../../Utils/graphql-sdk';
import useBookingTracking from 'Hooks/useBookingTracking';

const FlexibleRoutingWithData = () => {
  const { data: dockingLocations } = useBookingDockingLocations();
  const { state, dispatch } = useContext(bookingState);
  const track = useBookingTracking();

  useEffect(() => {
    if (!state.booking.pickupLocationId && !state.booking.dropoffLocationId) {
      const defaultPickUpLocation = dockingLocations?.find(
        (location) =>
          location?.default &&
          location?.operations.includes(DockingLocationOperation.Pickup)
      );

      if (defaultPickUpLocation?.id) {
        console.log('dispatching UPDATE_PICKUP_LOCATION', defaultPickUpLocation.id);
        dispatch({
          type: bookingActionTypes.UPDATE_PICKUP_LOCATION,
          payload: defaultPickUpLocation.id,
          keepTimeslot: false,
        });
      }

      const defaultDropOffLocation = dockingLocations?.find(
        (location) =>
          location?.default &&
          location?.operations.includes(DockingLocationOperation.Dropoff)
      );

      if (defaultDropOffLocation?.id) {
        console.log('dispatching UPDATE_DROPOFF_LOCATION', defaultDropOffLocation.id);
        dispatch({
          type: bookingActionTypes.UPDATE_DROPOFF_LOCATION,
          payload: defaultDropOffLocation.id,
          keepTimeslot: false,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dockingLocations]);

  if (!dockingLocations || dockingLocations.length === 0) return null;

  return (
    <FlexibleRouting
      pickupLocationId={state.booking.pickupLocationId}
      setPickUpLocation={(locationId) => {
        dispatch({
          type: bookingActionTypes.UPDATE_PICKUP_LOCATION,
          payload: locationId,
          keepTimeslot: false,
        });

        track({
          type: 'CHANGE_PICKUP_LOCATION',
          location: dockingLocations.find((location) => location.id === locationId)?.name,
        });
      }}
      dropoffLocationId={state.booking.dropoffLocationId}
      setDropOffLocation={(locationId) => {
        dispatch({
          type: bookingActionTypes.UPDATE_DROPOFF_LOCATION,
          payload: locationId,
          keepTimeslot: false,
        });

        track({
          type: 'CHANGE_DROPOFF_LOCATION',
          location: dockingLocations.find((location) => location.id === locationId)?.name,
        });
      }}
      dockingLocations={dockingLocations}
      boatCount={state.booking.boatCount}
    />
  );
};

export default FlexibleRoutingWithData;
